export const COORDINATOR = "COORDINATOR";
export const IDLE = "IDLE";
export const ACTIVE = "ACTIVE";
export const CLOSED = "CLOSED";
export const CANCEL = "CANCEL";

// URL
export const URL_ROOT = "/";
export const URL_LOGIN = "/login";
export const URL_CREATE = "/create";
export const URL_REGISTER = "/register";
export const URL_SURVEY = "/survey";
export const URL_SURVEYS = "/surveys";
export const URL_RESULTS = "/results";
